import { useWalletMultiButton } from "@solana/wallet-adapter-base-ui";
import { useWalletModal } from "@solana/wallet-adapter-react-ui";
import { useEffect, useState, useCallback } from "react";
import { useWallet } from "@solana/wallet-adapter-react";
import { fetchUserDetails, registerUser } from "@/network/users";
import { login, logout, setUser } from "@/redux/reducers/AuthReducer";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { toast } from "react-toastify";
import { getProvider } from "@/utils/helper";
import { store } from "@/redux/store";
import useJoinRoom from "@/customHooks/useJoinRoom";

export default function useConnectWallet(listen: boolean = false) {
  const [timestamp, setTimestamp] = useState(new Date().getTime());
  const { visible, setVisible } = useWalletModal();
  const {
    connected,
    signMessage,
    wallets,
    connect,
    select,
    disconnect,
    wallet,
  } = useWallet();
  const dispatch = useAppDispatch();
  const { token, user } = useAppSelector((state) => state.Auth);
  const isMobile = useAppSelector((state) => state.Config.isMobile);
  const { leaveRoom } = useJoinRoom();

  const {
    buttonState,
    onConnect,
    onDisconnect,
    onSelectWallet,
    publicKey,
    walletIcon,
    walletName,
  } = useWalletMultiButton({
    onSelectWallet() {
      setVisible(true);
    },
  });
  const address = publicKey?.toBase58() ?? "";
  const getSignInMessage = () => {
    const message = `Sign in to chingari.online at ${timestamp};`;
    const messageBytes = Buffer.from(message, "utf-8");
    return messageBytes;
  };
  const handleSignMessage = async () => {
    const currUser = store.getState().Auth.user;
    const currToken = store.getState().Auth.token;
    if (currUser && currToken) {
      return;
    }
    if (signMessage) {
      try {
        const messageBytes = getSignInMessage();
        const signature = await signMessage(messageBytes);
        const signatureBase64 = Buffer.from(signature).toString("base64");
        console.log(signature, signatureBase64);
        const requestBody = {
          loginType: "wallet",
          walletAddress: address,
          timestamp,
          signature: signatureBase64,
        };
        const response = await registerUser(requestBody);
        if (response && response.code == 200) {
          dispatch(
            login({ token: response.accessToken, user: response.userData })
          );
        }
        console.log(response);
      } catch (error) {
        if (onDisconnect) {
          onDisconnect();
        }
        dispatch(logout());
        console.error("Error signing message:", error);
      }
    }
  };
  const handleMobileSignIn = () => {
    if (connected && isMobile) {
      const provider = getProvider();
      if (provider) {
        console.log("use effect signin");
        handleSignMessage();
        return;
        // provider.signMessage(message).then(async (signature) => {
        //   const signatureBase64 = Buffer.from(signature).toString("base64");
        //   console.log(signature, signatureBase64);
        //   const requestBody = {
        //     loginType: "wallet",
        //     walletAddress: address,
        //     timestamp,
        //     signature: signatureBase64,
        //   };
        //   const response = await registerUser(requestBody);
        //   if (response && response.code == 200) {
        //     dispatch(
        //       login({ token: response.accessToken, user: response.userData })
        //     );
        //   }
        //   console.log(response);
        // });
      }
    } else if (isMobile) {
      leaveRoom();
    }
  };
  useEffect(() => {
    console.log("connected", connected, isMobile, user, token);
    let timer;
    timer = setTimeout(() => {
      handleMobileSignIn();
    }, 500);
    return () => {
      console.log("return");
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [connected, isMobile]);

  const handleSelectAndConnect = useCallback(
    async (walletName: string) => {
      try {
        // @ts-ignore
        select(walletName); // Select the wallet first
        setTimeout(async () => {
          try {
            // await connect(); // Now try connecting
            const res = await connect(); // Now try connecting
            console.log("Connected:", res, publicKey?.toBase58());
            console.log("handleSelectAndConnect");
            // handleSignMessage();
          } catch (err) {
            console.log("err", err);
          }
        }, 500); // Slight delay for selection to register
      } catch (error) {
        console.error("Error connecting:", error);
        alert("Wallet connection failed.");
      }
    },
    [select, connect, publicKey]
  );
  const onConnectClick = async () => {
    const provider = getProvider();
    console.log("buttonState", buttonState, !connected);
    if (isMobile && provider && !connected) {
      disconnect()
        .then((res) => {
          dispatch(logout());
          handleSelectAndConnect("Phantom");
          console.log("res", res);
        })
        .catch((err) => {
          console.log("err", err);
        });
      return;
      //   .finally(() => {
      //     console.log(wallet);
      //     wallet?.adapter
      //       .connect()
      //       .then((res) => {
      //         console.log("connected", res);
      //       })
      //       .catch((err) => {
      //         console.log("err", err);
      //       });
      //   });
    }

    // const response = await provider.connect();

    switch (buttonState) {
      case "no-wallet":
        setVisible(true);
        break;
      case "has-wallet":
        if (onConnect) {
          console.log("connect here");
          onConnect();
        }
        break;
    }
    return;
  };
  const handleButtonStateChange = async () => {
    if (buttonState === "has-wallet") {
      // if (walletName && walletName.toLowerCase() !== "phantom") {
      //   toast.error("Please Use Phantom Wallet");
      //   return;
      // }
      if (onConnect) {
        onConnect();
        return;
      }
    }
    if (buttonState === "connected" || connected) {
      //  verify Token
      if (token) {
        // const response = await fetchUserDetails(address);
        // if (response && response.data) {
        //   dispatch(setUser(response.data));
        // }
        return;
      }
      handleSignMessage();
    }
  };

  useEffect(() => {
    if (listen) {
      handleButtonStateChange();
    }
  }, [buttonState, listen]);
  return onConnectClick;
}
